import React from "react"
import { Modal, ModalHeader, ModalBody, Row, Col } from "reactstrap"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

const ScheduleDetailModal = ({ isOpen, toggle, data }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const { work_shifts, stations } = useSelector(state => state.Common)

  const displayFields = [
    { key: "day_num", label: t("Day Number") },
    { key: "shift", label: t("Shift") },
    { key: "national_id", label: t("National ID") },
    { key: "station", label: t("Station") },
    { key: "station_platform", label: t("Station Platform") },
    { key: "platform", label: t("Platform") },
    { key: "transporation_to_station", label: t("Transportation to Station") },
    {
      key: "transporation_to_station_note",
      label: t("Transportation to Station Note"),
    },
    {
      key: "transporation_to_station_train_movement",
      label: t("Transportation to Station Train Movement"),
    },
    { key: "accommodation", label: t("Accommodation") },
    { key: "trans_to_accomm", label: t("Transport to Accommodation") },
    {
      key: "trans_to_accomm_note",
      label: t("Transport to Accommodation Note"),
    },
    {
      key: "trans_to_accomm_train_movement",
      label: t("Transport to Accommodation Train Movement"),
    },
    { key: "work_train_movement", label: t("Work Train Movement") },
    { key: "work_note", label: t("Work Note") },
  ]

  const showDataFromObject = (list, key) => {
    const keys = Object.keys(list)
    if (keys.length === 0) return "-"

    return list[key][language === "en" ? "name" : "name_ar"]
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>{t("Roaster Details")}</ModalHeader>
      <ModalBody>
        <Row>
          {displayFields.map(({ key, label }) => (
            <Col xs="12" sm="6" className="mb-3" key={key}>
              <strong>{label}:</strong>
              {key === "shift" ? (
                <div>{showDataFromObject(work_shifts, data?.[key]) || "-"}</div>
              ) : key === "station" ? (
                <div>{showDataFromObject(stations, data?.[key]) || "-"}</div>
              ) : (
                <div>{data?.[key] || "-"}</div>
              )}
            </Col>
          ))}
        </Row>
      </ModalBody>
    </Modal>
  )
}

export default ScheduleDetailModal
